import anime from 'animejs'

export default {
    'sd-bars': {
        beforeEnter(group) {
            group.querySelectorAll('path').forEach(el => (el.style.opacity = 0))
        },
        enter(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                opacity: 1,
                duration: 1,
                delay: anime.stagger(200, { from: 'center' }),
                complete: done
            })
        },
        leave(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                opacity: [1, 0],
                duration: 1,
                delay: anime.stagger(200, { from: 'center' }),
                complete: done
            })
        },
        afterLeave(group) {}
    },
    'sd-circles': {
        beforeEnter(group) {
            group
                .querySelectorAll('circle')
                .forEach(el => (el.style.opacity = 0))
        },
        enter(group, done) {
            anime({
                targets: group.querySelectorAll('circle'),
                opacity: 1,
                delay: anime.stagger(100, { grid: [8, 3], from: 'center' }),
                easing: 'linear',
                complete: done,
                duration: 1
            })
        },
        leave(group, done) {
            anime({
                targets: group.querySelectorAll('circle'),
                opacity: 0,
                delay: anime.stagger(100, { grid: [8, 3], from: 'last' }),
                easing: 'linear',
                complete: done,
                duration: 1
            })
        }
    },
    'sd-squiggles': {
        enter(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                strokeDashoffset: [anime.setDashoffset, 0],
                easing: 'easeInSine',
                delay: anime.stagger(150, { from: 'first' }),
                complete: done
            })
        },
        leave(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                strokeDashoffset: [0, anime.setDashoffset],
                easing: 'easeInSine',
                delay: anime.stagger(150, { from: 'last' }),
                complete: done
            })
        }
    },
    'sd-squares': {
        enter(group, done) {
            anime({
                targets: group.querySelectorAll('rect'),
                opacity: [0, 1],
                duration: 1,
                complete: done,
                delay: anime.stagger(200, { grid: [8, 3], from: 'center' })
            })
        },
        leave(group, done) {
            anime({
                targets: group.querySelectorAll('rect'),
                opacity: [1, 0],
                duration: 1,
                delay: anime.stagger(200, { grid: [8, 3], from: 'first' }),
                complete: done
            })
        }
    },
    'sd-triangles': {
        enter(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                scale: [0, 1],
                delay: anime.stagger(50, {
                    grid: [8, 3],
                    from: 'center'
                }),
                duration: 600,
                easing: 'easeInOutQuad',
                complete: done
            })
        },
        leave(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                scale: [1, 0],
                delay: anime.stagger(50, {
                    grid: [8, 3],
                    from: 'last'
                }),
                duration: 300,
                easing: 'easeInOutQuad',
                complete: done
            })
        }
    },
    'sd-diamonds': {
        enter(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                scale: [0, 1],
                delay: anime.stagger(50, {
                    grid: [8, 3],
                    from: 'last',
                    axis: 'x'
                }),
                duration: 600,
                easing: 'steps(4)',
                complete: done
            })
        },
        leave(group, done) {
            anime({
                targets: group.querySelectorAll('path'),
                scale: [1, 0],
                delay: anime.stagger(50, {
                    grid: [8, 3],
                    from: 'first',
                    axis: 'x'
                }),
                duration: 300,
                easing: 'steps(4)',
                complete: done
            })
        }
    }
}
